import React from "react";
import { Row, Col, Button } from "react-bootstrap";

export default function contactUs() {
  return (
      <div className="contactUs" id="ContactUs">
      <div id="jumplink" className="anchor"></div>
        <div className="contactUsTitle pt-2 pb-2 mb-3">
          <h3 className="mb-0 contactTitle1">Send Us A</h3>
          <h3 className="mb-0 contactTitle2"> Message</h3>
        </div>
        <form id="contact-form" action="https://formsubmit.co/ogoley22@aim.com" method="POST">
          <Row xs={10} className="mx-0">
            <Col xs={12} sm={6} lg={12} className="mx-auto">
              <input type="hidden" name="_captcha" value="false"/>
              <input type="text" id="name-input" name="Name" placeholder="Your name" className="form-control contactInput" />
              <br />
              <input type="phone" id="phone-input" name="Phone" placeholder="Your phone number" className="form-control contactInput" />
              <br />
              <input type="email" id="email-input" name="Email" placeholder="Your email" className="form-control contactInput" />
              <br />
            </Col>
            <Col className="mx-auto">
              <textarea
                id="description-input"
                rows="3"
                placeholder="Your Message"
                className="form-control contactInput"
                name='Message'
              ></textarea>
              <br />
            </Col>
          </Row>
          <Button className="mb-3 mx-auto" type="submit">Submit</Button>
        </form>
      </div>
  );
}
